<template>
	<form action="/dashboard" method="GET" @submit.prevent="onSubmit">
		<div class="title-container">
			<div class="title">Sign Up</div>
		</div>

		<form-errors :errors="errors"></form-errors>

		<field-errors v-if="submitAttempted" :form="$v.form" field="name"></field-errors>
		<div class="input-container">
			<div class="input-title">Full Name</div>
			<div class="input-box"><input type="text" v-model="form.name"></div>
		</div>
		<field-errors v-if="submitAttempted" :form="$v.form" field="email"></field-errors>
		<div class="input-container">
			<div class="input-title">Email Address</div>
			<div class="input-box"><input type="email" v-model="form.email" placeholder="johnny@appleseed.com" autocomplete="email"></div>
		</div>
		<field-errors v-if="submitAttempted" :form="$v.form" field="email_confirmation"></field-errors>
		<div class="input-container">
			<div class="input-title">Confirm Email Address</div>
			<div class="input-box"><input type="email" v-model="form.email_confirmation" autocomplete="email"></div>
		</div>
		<field-errors v-if="submitAttempted" :form="$v.form" field="password"></field-errors>
		<div class="input-container">
			<div class="input-title">Password</div>
			<div class="input-box"><input type="password" v-model="form.password" placeholder="**************" autocomplete="new-password"></div>
		</div>
		<field-errors v-if="submitAttempted" :form="$v.form" field="password_confirmation"></field-errors>
		<div class="input-container">
			<div class="input-title">Confirm Password</div>
			<div class="input-box"><input type="password" v-model="form.password_confirmation" placeholder="**************" autocomplete="new-password"></div>
		</div>
		<submit-button text="Sign Up Now" icon="fa-key" :loading="formSaving" :has-errors="hasErrors"></submit-button>
	</form>
</template>

<script>

import { required, email, sameAs } from 'vuelidate/lib/validators';
import FormMixin from '@/mixins/FormMixin';

export default {

	props: {
		value: {
			type: Object,
			required: true,
		},
		action: {
			type: Function,
			default: () => {},
		},
	},

	mixins: [ FormMixin ],

	data() {
		return {
			form: this.value,
		};
	},

	validations: {
		form: {
			name: { required },
			email: { required, email },
			email_confirmation: {
				required,
				email,
				sameAs: sameAs('email'),
			},
			password: { required },
			password_confirmation: {
				required,
				sameAs: sameAs('password')
			},
		},
	},

	watch: {

		form: {
			deep: true,
			handler: function(newValue) {
				this.$emit('input', newValue);
			}
		},

	},

	methods: {

		onSubmit() {
			this.submit(async () => {
				await this.action();
			});
		},

	},

};

</script>
